module.exports = __webpack_public_path__ + "a508bd80cc0d0d1d7c0643cbdc1ad9a5.svg";